import { useEffect } from 'react';
import { BOTTOM_LAYER_ABOVE_SATELLITE } from '../../constants/map';

export const NAIP_LAYER_ID = 'mapbox-naip-layer';

const NaipLayer = ({ map }) => {
  useEffect(() => {
    map.addSource('mapbox-naip', {
      type: 'raster',
      url: 'mapbox://mapbox.naip',
      minZoom: 12,
      maxZoom: 18,
    });

    map.addLayer(
      {
        id: NAIP_LAYER_ID,
        source: 'mapbox-naip',
        type: 'raster',
        minZoom: 12,
      },
      BOTTOM_LAYER_ABOVE_SATELLITE,
    );

    return () => {
      // eslint-disable-next-line no-underscore-dangle
      if (map && !map._removed) {
        map.removeLayer(NAIP_LAYER_ID);
        map.removeSource('mapbox-naip');
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default NaipLayer;
